import React, { useState, useRef, useEffect } from "react";
import Navbar from "./Navbar";
import "../App.css";
import "./KeyStatisticsContent.css";
import Container from "@material-ui/core/Container";
import KeyData from "./KeyData.json";
import AdminPage from "./Admin/AdminPage";
import axios from "axios";
import Alert from "@mui/material/Alert";
import { baseURL } from "../../src/Constant";
function KeyStatisticsContent() {
  const [portalData, setPortalData] = useState(KeyData);
  const ref = useRef(null);

  const [DBData, setDBData] = useState();
  const [bool, setBool] = useState(false);
  const [fetchError, setFetchError] = useState(false);
  console.log(baseURL,"baseURL");
  // const [show, setShow] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getStatistics`,
          // "http://localhost:3002/getStatistics",
          {
            headers: {
              Authorization: localStorage.getItem("token"),
              "Content-Type": "application/json",
            },
          }
        );

        setDBData(response.data.admins);
        console.log(response.data.admins, "response from axios");
      } catch {
        setFetchError(true);
      }
    };
    fetchData();
    setBool(false);
    // console.log(bool, "bool check");
  }, [bool]);
  return (
    <>
      <div className="tech-container main-container" id="keystatistics-box">
        <title>Job Readiness - Key Statistics</title>
        <h1 className="sr-only" tabIndex={0}>
          Job Readiness - Key Statistics
        </h1>
        <img
          src="/images/key-statistics-new.jpg"
          alt="banner-image"
          className="banner-img"
        />
        <Navbar />
      </div>
      {fetchError && (
        <Alert severity="error" className="errorAlert">
          <b>Internal Server Error:</b> Please try again with a hard refresh. If
          the issue persists, contact the LIS team for further assistance.
        </Alert>
      )}
      {/* <div ref={ref}> */}
      <AdminPage setBool={setBool}></AdminPage>
      {/* </div> */}
      {console.log(portalData, "portal data in keyStats")}
      <h1>Pre Joining Learning</h1>
      <Container className="keystatic-sec" id="main">
        <div className="row second-row">
          {DBData?.map((keypost) => {
            return (
              <div className="keystatic-wrap">
                <div className="keystatic-box">
                  <div key={keypost.id}>
                    <img src={keypost.image} alt="" />
                    <h2 className="numberText">
                      {keypost.number} <span>{keypost.addons}</span>
                    </h2>
                    <p>{keypost.content}</p>
                  </div>
                </div>
              </div>
            );
          })}
          {/* {portalData.map(keypost => {
                        return (
                            <div className="keystatic-wrap">
                                <div className="keystatic-box">
                                    <div key={keypost.id}>
                                        <img src={keypost.image} alt="image" />
                                        <h3>{keypost.number} <span>{keypost.contentspan}</span></h3>
                                        <p>{keypost.content}</p>
                                    </div>
                                </div>
                            </div>
                        )
                    })} */}
        </div>
      </Container>

      {/* {
            "id": 6,
            "image":"/images/statistics-img6.png",
            "number": 42605,
            "content":"Number of ASEs who have already completed first 2 weeks of learning"
            }, */}

      <div className="about-date">
        {/* <p>Key Statistics from Dec 2020 till date</p> */}
        <p>Key Statistics from Oct 2024 till date</p>
      </div>
    </>
  );
}

export default KeyStatisticsContent;
